import script from "./editWork.vue?vue&type=script&setup=true&lang=js"
export * from "./editWork.vue?vue&type=script&setup=true&lang=js"

import "./editWork.vue?vue&type=style&index=0&id=07c3bd22&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07c3bd22"]])

export default __exports__